/**
 * Brand Configuration
 * Single source of truth for multi-brand support (Tax.Network, Tributário)
 */

import { TAX_NETWORK_DOMAIN, TRIBUTARIO_DOMAIN } from '@/constants/branding';

export type BrandId = 'tax_network' | 'tributario';

export interface BrandConfig {
  id: BrandId;
  displayName: string;
  logoSrc: string;
  logoAlt: string;
  hostname: string;
  websiteUrl: string;
  supportEmail: string;
  supportName: string;
}

export const BRANDS: Record<BrandId, BrandConfig> = {
  tax_network: {
    id: 'tax_network',
    displayName: 'Tax.Network',
    logoSrc: '/logo-tax-network.svg',
    logoAlt: 'Tax.Network',
    hostname: TAX_NETWORK_DOMAIN,
    websiteUrl: `https://${TAX_NETWORK_DOMAIN}`,
    supportEmail: 'support@tax.network',
    supportName: 'Tax.Network Support',
  },
  tributario: {
    id: 'tributario',
    displayName: 'Tributário',
    logoSrc: '/logo-tributario.png',
    logoAlt: 'Tributário',
    hostname: TRIBUTARIO_DOMAIN,
    websiteUrl: `https://${TRIBUTARIO_DOMAIN}`,
    supportEmail: 'atendimento@tributario.com.br',
    supportName: 'Atendimento Tributário',
  },
};

export const DEFAULT_BRAND: BrandId = 'tax_network';
